var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('img',{staticClass:"gear-icon",attrs:{"src":`${_vm.publicPath}/icons/ai-response/gear.svg`,"alt":"","height":"60"}}),_c('img',{staticClass:"glare-icon",attrs:{"src":`${_vm.publicPath}/icons/ai-response/glare.svg`,"alt":"","height":"60"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }